import React, { type ReactNode } from 'react';

import { ThemeProvider, Global, css } from '@emotion/react';
import { ERebrandingColors } from 'helpers/constants';

import createTheme from '@eduzz/houston-ui/ThemeProvider/createTheme';

/** Não importar @eduzz/houston-ui/ThemeProvider: o barrel chama createTheme('eduzz') no load e quebra no Orbita. */
// const federationTheme = createTheme('eduzz');
const federationTheme = createTheme('#0D2772');

const primaryButtonSelectors = `
  #registry-block-modal-ok-button.ant-btn-primary:not(:disabled),
  #registry-block-modal-ok-button.ant-btn-color-primary:not(:disabled),
  #registry-block-modal-ok-button.ant-btn-variant-solid:not(:disabled),
  #registry-block-modal-copy-button.ant-btn-primary:not(:disabled),
  #registry-block-modal-copy-button.ant-btn-color-primary:not(:disabled),
  #registry-block-modal-copy-button.ant-btn-variant-solid:not(:disabled)
`;

const registryBlockModalOverrides = css`
  /*
   * O Modal do Ant Design renderiza via portal no document.body,
   * fora do wrapper .registry-block-modal-bridge — seletores globais por ID.
   */
  ${primaryButtonSelectors} {
    --ant-color-primary: ${ERebrandingColors.MAIN};
    background: ${ERebrandingColors.MAIN} !important;
    border-color: ${ERebrandingColors.MAIN} !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    min-height: 40px !important;
    height: auto !important;
    padding: 7.75px 16px !important;
    line-height: normal !important;
  }

  ${primaryButtonSelectors}:hover,
  ${primaryButtonSelectors}:focus {
    background: ${ERebrandingColors.MAIN} !important;
    border-color: ${ERebrandingColors.MAIN} !important;
  }
`;

type Props = { children: ReactNode };

/**
 * Tema Houston (emotion/styled) para o remoto + overrides CSS para Ant Design do bundle federado.
 * Evita antd v5 no host: o vertical já carrega sua própria instância via Module Federation.
 */
const RegistryBlockModalBridge = ({ children }: Props) => (
  <ThemeProvider theme={federationTheme as any}>
    <Global styles={registryBlockModalOverrides} />
    <div className='registry-block-modal-bridge'>{children}</div>
  </ThemeProvider>
);

export default RegistryBlockModalBridge;
